import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import FilterByDate from "./components/FilterByDate";
import LabBottomNavigation from "../../components/LabBottomNavigation";
import LabTransactionItem from "./components/LabTransactionItem";
import ListEmpty from "../../components/ListEmpty";
import Loading from "../../components/Loading";
import MessagesList from '../dashboard/components/messages/MessagesList'
import MobileBottomPagination from "../../layouts/components/MobileBottomPagination";
import PharmacyTransactionItem from "./components/PharmacyTransactionItem";
import TransactionsListExcel from "./TransactionsListExcel"
import {getAllTransactions,filterOrdersByDate} from "../../redux/actions/transactions";
import {getVendorType} from "../../services/auth";

const TransactionsMobile = (props) => {
    const dispatch = useDispatch();
    const list_empty_message = "موردی جهت نمایش وجود ندارد";
    const vendor_type = getVendorType();
    const {all_transactions_success, all_transactions_waiting} = useSelector(state => state.transactions);
    const {filter_transactions_success,filter_transactions_waiting} = useSelector(state => state.transactions);
    const [totalItems, setTotalItems] = useState(10);
    const [filterState, setFilterState] = useState(false)
    const [excelUrl , setExcelUrl] = useState('')
    const [query,setQuery] = useState({
        page : 1,
        per_page : 10
    });
    const [transactions, setTransactions] = useState(
        {
            transactions : [],
            total : 0,
            current : 1,
            per_page : 10
        }
    );

    const [message, setMessage] = useState({})
    useEffect(() => {
        dispatch(getAllTransactions({
            page: 1,
            per_page: 10
        }));
    }, [dispatch, query]);

    useEffect(() => {
        if (all_transactions_success.result && all_transactions_success.result === 'SUCCESS') {
            setTransactions({
                transactions: all_transactions_success.data.transactions,
                total: all_transactions_success.data.total,
                current: all_transactions_success.data.page,
                per_page: all_transactions_success.data.totalItems
            });
            setTotalItems(all_transactions_success.data.total)
        }
    }, [all_transactions_success]); 


    useEffect(() => {
        if (filter_transactions_success.result && filter_transactions_success.result === 'SUCCESS'){
            setExcelUrl(filter_transactions_success.data.url)
            setFilterState(true)
        }
    },[filter_transactions_success]);

    const setFilterDate = async (start,end) => {
        if(start !== null && end !== null && start !== undefined && end !== undefined){
            setMessage({
                show: false,
                message: []
            })
            const checkNumUnderTen = (num) => {
                if(num < 10) {
                    return `0${num}`
                } else {
                    return num
                }
            }
            const dateMomentStart = `${start.year}/${checkNumUnderTen(start.month)}/${checkNumUnderTen(start.day)}`
            const dateMomentEnd = `${end.year}/${checkNumUnderTen(end.month)}/${checkNumUnderTen(end.day)}`
            const date ={
                from: dateMomentStart,
                to: dateMomentEnd
            }
            await dispatch(filterOrdersByDate({...date}))
        } else {
            setMessage({
                show: true,
                message: [{
                    type: "danger",
                    message: "لطفا تاریخ معتبری وارد نمایید."
                }]
            })
        }
    }

    return (
        <>
        <div className='all-orders-list-mobile'>
            {
                vendor_type !== 'DRUG' ? <LabBottomNavigation {...props} /> : null
            }
                                    <FilterByDate mobileMode setFilterDate={(startDate, endDate) => {setFilterDate(startDate, endDate)}}  removeFilterDate = {() => {
                            dispatch(getAllTransactions({
                                page: 1,
                                per_page: 10
                            }));
                            setFilterState(false)
                        }}/>
                {all_transactions_waiting ? <Loading/> :
                transactions.transactions.length !==0 ? (
                vendor_type !== 'DRUG' ? (
                    <>
                                        {filterState && (                
                        <div className="col-lg-12 col-md-12 page-header">    
                        <a href={excelUrl} target="_blank" style={{width:'100%',marginBottom:'16px'}} className="btn btn-sm btn-success btn-export">دانلود خروجی اکسل</a>
                    {/* <TransactionsListExcel transactions={transactions} /> */}
                        </div>
                    )}
                        {Object.keys(message).length !== 0 && message !== null && message !== undefined && (<MessagesList messages={message.message}/>)}
                        {transactions.transactions.map((transaction,index) => {
                            return <LabTransactionItem {...transaction} key={index} />
                        })}
                    </>
                ) : (
                    <>
                                        {filterState && (                
                        <div className="col-lg-12 col-md-12 page-header">    
                        <a href={excelUrl} target="_blank" style={{width:'100%',marginBottom:'16px'}} className="btn btn-sm btn-success btn-export">دانلود خروجی اکسل</a>
                    {/* <TransactionsListExcel transactions={transactions} /> */}
                        </div>
                    )}
                        {Object.keys(message).length !== 0 && message !== null && message !== undefined && (<MessagesList messages={message.message}/>)}
                        {transactions.transactions.map((transaction,index) => {
                            return <PharmacyTransactionItem {...transaction} key={index} />
                        })}
                    </>                   
                )
                ) : (
                    <ListEmpty message={list_empty_message} />
                )
            }
            {vendor_type !=="DRUG" ? (
            
            (!all_transactions_waiting && transactions.transactions.length !==0) && (
                <div className="actions-report-lab-mobile">

                    <MobileBottomPagination
                        total={transactions.total}
                        current={transactions.current}
                        per_page={transactions.per_page}
                        className="mobile-items-lab-pagination"
                        api={getAllTransactions}
                    />
                </div>
            )
            
        ) : (
            (!all_transactions_waiting && transactions.transactions.length !==0) && (
                <div className="actions-report-lab-mobile">
                <MobileBottomPagination
                total={transactions.total}
                current={transactions.current}
                per_page={transactions.per_page}
                api={getAllTransactions}
                />

                </div>
            )
        )}
        </div>


    </>
    )
};

export default TransactionsMobile;